import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import PageLoader from './components/PageLoader.vue'
import PushNotifications from './components/PushNotifications.vue'
import './assets/crm.css'
import './assets/style.css'
import './assets/dashboard.css'
createApp(App).component('PageLoader', PageLoader).component('PushNotifications', PushNotifications).use(store).use(router).mount('#app')
